import { CustomerAddress } from './interfaces/customer-address';

export class Customer {
    alternate_email: string;
    birthday: string;
    currency: {
        amount: number
    };
    name: string;
    email: string;
    phone_no: number;
    customer_addresses: CustomerAddress[];
    is_veg: boolean;
    referral_code: string;
    verified_phone: boolean;
    linked_wallets: string[];
    subscription: {
        allow_sms: boolean,
        allow_mail: boolean
    };
    customer_info: {
        birthday: string;
    }
}
